function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/real-estate-listing.css";
// @ts-ignore
import ValuationBanner from "./vue/ValuationBanner.vue";
import axios from "axios";
// @ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
import "core-js/modules/es.array.iterator";
import * as Listing from "./components/listing";
import { LISTING_MODE } from "./components/listing";
//@ts-ignore
import { decodeCookie, encodeCookie, removeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { parsePoints, calcPolygonCenter } from "@utils/MapUtils";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
//@ts-ignore
import PlaceBox from "@vueEntry/PlaceBox.vue";
//@ts-ignore
import { updateRealEstateSearch, updateViewListing } from "@services/statisticsAPI";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
//@ts-ignore
import { useFavourite } from "@wkComposables/useFavourite";
import commonAsyncComponents from "./vue/CommonComponents/CommonModals";
import { Modals } from "./Types/Modals";
//@ts-ignore
import { useSaveSearchModal } from "@wkComposables/useSaveSearchModal";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import { COLORS, MAP_TILER_APIKEY } from "@wkWebSrc/js/components/variables";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
// @ts-ignore
import { getMapMarkers, getRealEstatesData } from "@services/realEstateAPI";
// @ts-ignore
import BaseTooltip from "@vueEntry/UIKitComponents/BaseTooltip.vue";
// @ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { createApp, defineAsyncComponent, ref } from "vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
//@ts-ignore
import BlogBanner from "@vueEntry/BlogBanner.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
//@ts-ignore
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
import { mapActions, mapState, createPinia } from "pinia";
import { useBaseStore, useSearchBeanStore, useModalStore, usePublicUserMenuStore, useLoggedUserStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import { IMAGE_FORMATS as _IMAGE_FORMATS } from "@customTypes/ImageFormatsEnum";
//@ts-ignore
import { transformReImages } from "@utils/ImageUtils";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
// @ts-ignore
import { MailIcon } from "@vueEntry/SvgIcons/MailIcon";
// @ts-ignore
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import InsertionCard from "@vueEntry/InsertionCard.vue";
//@ts-ignore
import ShimmerLoader from "@vueEntry/ShimmerLoader.vue";
//@ts-ignore
import { redirectToApp } from "@utils/AppRedirectUtils";
var insertionHandlerClick = null;
var insertionMediaWrapperClick = null;
var realEstateListingApp = createApp({
  name: "RealEstate",
  components: Object.assign(Object.assign(Object.assign(Object.assign({
    //@ts-ignore
    "filters-modal": defineAsyncComponent(function () {
      return import("@vmodals/FiltersModal.vue");
    }),
    //@ts-ignore
    "orders-modal": defineAsyncComponent(function () {
      return import("@vueEntry/Modals/OrderModal.vue");
    }),
    //@ts-ignore
    cchart: defineAsyncComponent(function () {
      return import("@vueEntry/cchart.vue");
    }),
    AccessibleSelect: AccessibleSelect,
    ValuationBanner: ValuationBanner,
    PublicUserMenu: PublicUserMenu,
    PlaceBox: PlaceBox,
    BaseButton: BaseButton,
    BaseIcon: BaseIcon,
    BaseComplexToggle: BaseComplexToggle,
    BaseTooltip: BaseTooltip,
    BaseBtModal: BaseBtModal,
    BaseDropDown: BaseDropDown,
    BlogBanner: BlogBanner,
    InsertionCard: InsertionCard,
    ShimmerLoader: ShimmerLoader,
    //@ts-ignore
    "base-sidebar": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseSidebar.vue");
    }),
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(function () {
      return import("@vueEntry/SwiperCarousel.vue");
    }),
    IntersectionObservableVue: IntersectionObservableVue,
    IntersectionObserverVue: IntersectionObserverVue,
    BaseBadge: BaseBadge,
    //@ts-ignore
    "map-modal": defineAsyncComponent(function () {
      return import("@vmodals/MapModal.vue");
    }),
    //@ts-ignore
    "place-modal": defineAsyncComponent(function () {
      return import("@vmodals/PlaceModal.vue");
    }),
    //@ts-ignore
    "save-search-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/SaveSearchModal.vue");
    }),
    //@ts-ignore
    "share-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/ShareModal.vue");
    }),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/ContactAgencyModal.vue");
    }),
    //@ts-ignore
    "mail-alert-on-favourite-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/MailAlertOnFavouriteModal.vue");
    })
  }, commonAsyncComponents), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }), LanguageIcons), {
    MailIcon: MailIcon,
    PhoneIcon: PhoneIcon
  }),
  setup: function setup() {
    var seoFilters = ref();
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useBaseSnackbar = useBaseSnackbar(),
      showBaseSnackbar = _useBaseSnackbar.showBaseSnackbar,
      handleShowSnackbar = _useBaseSnackbar.handleShowSnackbar,
      baseSnackbarProps = _useBaseSnackbar.baseSnackbarProps;
    var _useFavourite = useFavourite(),
      handleAddFavorite = _useFavourite.handleAddFavorite,
      handleRemoveFavorite = _useFavourite.handleRemoveFavorite;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    var _useContactAgencyModa = useContactAgencyModal(),
      agencyModalData = _useContactAgencyModa.agencyModalData,
      reopenAfterLogin = _useContactAgencyModa.reopenAfterLogin,
      successModalDataEmitted = _useContactAgencyModa.successModalDataEmitted,
      amdLabels = _useContactAgencyModa.amdLabels,
      amdIcons = _useContactAgencyModa.amdIcons,
      listingType = _useContactAgencyModa.listingType,
      openContactModal = _useContactAgencyModa.openContactModal,
      openAndReturnToCAMS = _useContactAgencyModa.openAndReturnToCAMS;
    var _useSaveSearchModal = useSaveSearchModal(),
      saveSearchModalIcons = _useSaveSearchModal.saveSearchModalIcons,
      saveSearchModalLabels = _useSaveSearchModal.saveSearchModalLabels,
      realEstateMiniItem = _useSaveSearchModal.realEstateMiniItem,
      realEstateBean = _useSaveSearchModal.realEstateBean,
      ssmPlace = _useSaveSearchModal.ssmPlace;
    var _useSearch = useSearch(),
      search = _useSearch.search,
      setOrderAndSearch = _useSearch.setOrderAndSearch;
    var _useShareModal = useShareModal(),
      shareModalData = _useShareModal.shareModalData,
      openShareModal = _useShareModal.openShareModal,
      gaEvent = _useShareModal.gaEvent;
    var _useShowPhone = useShowPhone(),
      showPhone = _useShowPhone.showPhone;
    var _useUtilities = useUtilities(),
      redirectTo = _useUtilities.redirectTo;
    var _useBreakpoints = useBreakpoints(),
      isLarge = _useBreakpoints.isLarge,
      isDesktopMode = _useBreakpoints.isDesktopMode;
    return {
      isLarge: isLarge,
      isDesktopMode: isDesktopMode,
      showPhone: showPhone,
      isAppBannerVisible: isAppBannerVisible,
      showBaseSnackbar: showBaseSnackbar,
      handleShowSnackbar: handleShowSnackbar,
      baseSnackbarProps: baseSnackbarProps,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData: agencyModalData,
      reopenAfterLogin: reopenAfterLogin,
      successModalDataEmitted: successModalDataEmitted,
      //CAM computed
      amdLabels: amdLabels,
      amdIcons: amdIcons,
      listingType: listingType,
      //CAM methods
      openContactModal: openContactModal,
      openAndReturnToCAMS: openAndReturnToCAMS,
      handleAddFavorite: handleAddFavorite,
      handleRemoveFavorite: handleRemoveFavorite,
      //useFirebaseMessaging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick,
      //useSaveSearch
      saveSearchModalIcons: saveSearchModalIcons,
      saveSearchModalLabels: saveSearchModalLabels,
      realEstateMiniItem: realEstateMiniItem,
      realEstateBean: realEstateBean,
      ssmPlace: ssmPlace,
      //useSearch
      search: search,
      setOrderAndSearch: setOrderAndSearch,
      //useShareModal
      shareModalData: shareModalData,
      openShareModal: openShareModal,
      gaEvent: gaEvent,
      redirectTo: redirectTo,
      seoFilters: seoFilters
    };
  },
  data: function data() {
    return {
      wikiDescriptionShowMore: false,
      ListingInit: {
        list: "#list-properties",
        "getMapMarkers": getMapMarkers,
        "buildInfoWindow": buildInfoWindow,
        click: true
      },
      updateSSCSet: false,
      aroundMe: false,
      place: JSON.parse(_serializedPlace),
      isSale: isSale,
      isRent: isRent,
      graphDataResponse: [],
      graphData: [],
      smScreen: window.screen.width < BREAKPOINT.SMALL,
      activeListener: true,
      activeMode: "Lista",
      observerOptions: {
        rootMargin: "0px",
        threshold: 1.0
      },
      chartIsShowed: false,
      /* Shows the saveSearch popup */
      mapInitialized: false,
      agencyFilter: null,
      customListingTypologyURL: "",
      useContractType: true,
      casaClickHover: false,
      popoverVisible: false,
      map: null,
      isAuction: false,
      consultants: [],
      isBtnScrollLeftVisible: false,
      isBtnScrollRightVisible: true,
      previewCardRealEstateMap: [],
      isPreviewCardSidebarVisible: false,
      lastMarkersClicked: [],
      loadingPreviewCard: false,
      closeSidebar: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    IMAGE_FORMATS: function IMAGE_FORMATS() {
      return _IMAGE_FORMATS;
    },
    mapRangeForMarkers: function mapRangeForMarkers() {
      return window._freesearch || this.searchBean.placeType == PLACE_TYPE.REGION || this.searchBean.placeType == PLACE_TYPE.PROVINCE ? 1000000 : window._mapRange;
    },
    checkedMap: function checkedMap() {
      return window.location.hash === "#map";
    },
    checkedList: function checkedList() {
      return !this.checkedMap || window.location.hash === "#list";
    },
    polygonPoints: function polygonPoints() {
      return this.searchBean.polygonFromMap ? parsePoints(this.searchBean.polygonFromMap) : [];
    },
    currentMapCenter: function currentMapCenter() {
      var _a, _b;
      return this.searchBean.polygonFromMap ? calcPolygonCenter(this.polygonPoints) : {
        lat: ((_a = this.place) === null || _a === void 0 ? void 0 : _a.latitude) || 42.4153262,
        lng: ((_b = this.place) === null || _b === void 0 ? void 0 : _b.longitude) || 12.6428742
      };
    },
    listMode: function listMode() {
      return this.activeMode === "Lista";
    },
    mapMode: function mapMode() {
      return !this.listMode;
    },
    orderOptions: function orderOptions() {
      return window["orderOptions"];
    },
    orderSelected: function orderSelected() {
      var _this = this;
      return this.orderOptions.find(function (option) {
        return option.id === _this.searchBean.filterOrderId;
      }) || {
        id: 0
      };
    },
    realEstateSearchBean: function realEstateSearchBean() {
      var _serializedSearchBean = window["_serializedSearchBean"];
      if (!_serializedSearchBean) return {};
      return JSON.parse(_serializedSearchBean);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(useSearchBeanStore, ["searchBean"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name", "favoriteIdList", "lastFavouriteModifiedId"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  watch: {
    activeMode: function activeMode(cur) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(cur === LISTING_MODE.MAP)) {
                _context.next = 16;
                break;
              }
              sendGAEvent("re_listing_view", {
                view_type: "map",
                event_location: this.pageName,
                real_estate_contract_type: window._listing_contract_type
              });
              (_a = this.$refs.mapButton) === null || _a === void 0 ? void 0 : _a.classList.add("tw-hidden");
              (_b = this.$refs.listButton) === null || _b === void 0 ? void 0 : _b.classList.remove("tw-hidden");
              (_c = this.$refs.footer) === null || _c === void 0 ? void 0 : _c.classList.add("tw-hidden");
              (_d = this.$refs.footer) === null || _d === void 0 ? void 0 : _d.classList.remove("tw-block");
              window.history.pushState(Date.now(), "", "#map");
              if (this.mapInitialized) {
                _context.next = 13;
                break;
              }
              _context.next = 10;
              return this.initMap();
            case 10:
              this.mapInitialized = true;
              _context.next = 14;
              break;
            case 13:
              window.dispatchEvent(new Event("resize"));
            case 14:
              _context.next = 22;
              break;
            case 16:
              sendGAEvent("re_listing_view", {
                view_type: "default",
                event_location: this.pageName,
                real_estate_contract_type: window._listing_contract_type
              });
              window.history.pushState(Date.now(), "", "#list");
              (_e = this.$refs.listButton) === null || _e === void 0 ? void 0 : _e.classList.add("tw-hidden");
              (_f = this.$refs.mapButton) === null || _f === void 0 ? void 0 : _f.classList.remove("tw-hidden");
              (_g = this.$refs.footer) === null || _g === void 0 ? void 0 : _g.classList.add("tw-block");
              (_h = this.$refs.footer) === null || _h === void 0 ? void 0 : _h.classList.remove("tw-hidden");
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    },
    favoriteIdList: {
      handler: function handler(cur, prev) {
        if (this.map) {
          if (cur.length < prev.length) {
            this.map.updateIconFavourite(this.lastFavouriteModifiedId, false);
          } else {
            this.map.updateIconFavourite(this.lastFavouriteModifiedId, true);
          }
        }
      },
      deep: true
    }
  },
  created: function created() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            this.checkedList && sendGAEvent("re_listing_view", {
              view_type: "default",
              event_location: this.pageName,
              real_estate_contract_type: window._listing_contract_type
            });
            this.updateRES();
            this.initPublicUserMenu();
            this.addShareOnMapEvent();
            /*this.showSaveSearchTooltip();*/ // temp disabilitato, cambio SEO, da tenere in in caso possa riservire a breve
            this.updateSearchBean(JSON.parse(window._serializedSearchBean));
            //default set to disclaimer
            this.openModal("DISCLAIMER_MODAL");
            this.isAuction = this.searchBean.contractType == 3;
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
  },
  mounted: function mounted() {
    var _this2 = this;
    hideZonesBreadcrumb();
    Listing.init({
      list: "#list-properties",
      getMapMarkers: getMapMarkers,
      buildInfoWindow: buildInfoWindow
    });
    if (!window["_bot"]) {
      updateViewListing(Listing.page.map(function (re) {
        return {
          agencyId: re.agencyId,
          realEstateId: re.id
        };
      }));
    }
    var chartContainer = document.getElementById("container-chart");
    if (!chartContainer) return;
    var observerTarget = chartContainer;
    if (chartContainer) {
      var callback = function callback(entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            import("chart.js").then(function () {
              _this2.chartIsShowed = true;
              _this2.getGraphData(isSale).then(function () {
                observer.unobserve(observerTarget);
              });
            });
          }
        });
      };
      var observer = new IntersectionObserver(callback, this.observerOptions);
      observer.observe(chartContainer);
    }
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    transformReImages: transformReImages,
    handleBreadcrumbLinkClick: handleBreadcrumbLinkClick,
    handleInsertionClick: handleInsertionClick,
    useApp: function useApp() {
      redirectToApp("Listato - Banner");
    },
    openModal: function openModal(modalName) {
      this.setShowModal(modalName);
    },
    closeModal: function closeModal() {
      this.setShowModal("NO_MODAL");
    },
    openMap: function openMap(obj) {
      this.aroundMe = obj.aroundMe;
      this.setShowModal("MAP_MODAL");
    },
    updateRES: function updateRES() {
      if (!decodeCookie("newSearch")) return;
      updateRealEstateSearch(this.realEstateSearchBean).then(function () {
        removeCookie("newSearch");
      });
    },
    closeSaveSearchModal: function closeSaveSearchModal() {
      encodeCookie("saveSearchModal", {}, 1);
      this.setShowModal(Modals.noModal);
    },
    showSaveSearchTooltip: function showSaveSearchTooltip() {
      var _this3 = this;
      var ssCookie = decodeCookie("saveSearchModal");
      if (ssCookie !== null && !window._freesearch) return;
      if (window.screen.width >= 992 && window["_showSaveSearchModal"] && !window._freesearch && !window.location.search.includes("privateArea=true") && !window.location.search.includes("c=0")) {
        this.setShowModal(Modals.saveSearchModal);
      } else if (window.screen.width < 576 && !window.location.search.includes("privateArea=true")) {
        this.popoverVisible = true;
        var rootEl = document.getElementById("real-estate-main");
        ["click", "scroll"].forEach(function (eventName) {
          rootEl === null || rootEl === void 0 ? void 0 : rootEl.addEventListener(eventName, function () {
            _this3.hidePopoverMailAlert();
          });
        });
      }
    },
    getGraphData: function getGraphData(sale) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var filters, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              filters = {
                contract: "sale",
                macroTypologyId: 1
              };
              if (!sale) {
                filters.contract = "rent";
              }
              _context3.prev = 2;
              _context3.next = 5;
              return axios.post("/rest/statistics/getAveragePriceGraphData/".concat(filters.contract, "/").concat(filters.macroTypologyId), this.place, {
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
                }
              });
            case 5:
              response = _context3.sent;
              this.graphDataResponse = response.data;
              this.graphData = this.graphDataResponse.slice(Math.max(this.graphDataResponse.length - 12));
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);
              console.error(_context3.t0);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 10]]);
      }));
    },
    addShareOnMapEvent: function addShareOnMapEvent() {
      var _this4 = this;
      document.addEventListener("share-event", function (e) {
        var payload = e.detail;
        _this4.openShareModal(payload, "".concat(_this4.pageName, " - Card Mappa"), "real_estate_share");
      });
    },
    initMap: function initMap() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this5 = this;
        var _yield$Promise$all, _yield$Promise$all2, leafletModule, leafletThemeModule, mapCssModule, leaflet, map_selector;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return Promise.all([
              //@ts-ignore
              import( /* webpackChunkName: "chunks/leaflet_map" */"@wkWebSrc/js/LeafletMap/leaflet_map"), require( /* webpackChunkName: "chunks/leaflet_theme" */"../style/vendor/leafleft.theme.css"), require( /* webpackChunkName: "chunks/map" */"../style/layout/map.css")]);
            case 2:
              _yield$Promise$all = _context5.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              leafletModule = _yield$Promise$all2[0];
              leafletThemeModule = _yield$Promise$all2[1];
              mapCssModule = _yield$Promise$all2[2];
              leaflet = leafletModule["default"];
              this.map = new leaflet();
              map_selector = this.$refs.listingMapPlaceholder;
              _context5.prev = 10;
              _context5.next = 13;
              return (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(map_selector, MAP_TILER_APIKEY, COLORS, undefined, undefined, this.isDesktopMode ? 12 : 11);
            case 13:
              if (!this.isDesktopMode) {
                this.map.on("click", function () {
                  var _a, _b;
                  _this5.isPreviewCardSidebarVisible = false;
                  _this5.loadingPreviewCard = false;
                  (_a = document.getElementById("open-map-modal-btn-mobile")) === null || _a === void 0 ? void 0 : _a.classList.add("is-transitioned");
                  (_b = document.getElementById("save-search-button-mobile-map")) === null || _b === void 0 ? void 0 : _b.classList.add("is-transitioned");
                });
              }
              this.map.startSpinner();
              (_b = this.ListingInit.getMapMarkers()) === null || _b === void 0 ? void 0 : _b.then(function (markers) {
                var _a, _b;
                if (_this5.polygonPoints.length) {
                  (_a = _this5.map) === null || _a === void 0 ? void 0 : _a.deleteShape();
                  (_b = _this5.map) === null || _b === void 0 ? void 0 : _b.drawPolygonFromPoints(_this5.polygonPoints);
                }
                if (markers.length > 0) {
                  _this5.map.initMarkerClusterer();
                  _this5.map.addMarkerBulk(markers, _this5.currentMapCenter, _this5.mapRangeForMarkers, _this5.favoriteIdList);
                }
                if (_this5.map.hasShape()) _this5.map.fitBounds(_this5.map.getShape().getBounds());else if (_this5.map.getMarkersCount()) _this5.map.fitBounds(_this5.map.getMarkerClusterer().getBounds());
                _this5.map.getMap().invalidateSize();
                _this5.map.on("click movestart", function () {
                  if (_this5.isDesktopMode) _this5.closeSidebar = true;
                });
                //Single marker
                _this5.map.addListener(_this5.map.getMarkerClusterer(), "click", function (e) {
                  return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                    var _c, _d, marker, space, lat, _this$lastMarkersClic;
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          marker = e.propagatedFrom;
                          if (!this.isDesktopMode) {
                            (_c = document.getElementById("open-map-modal-btn-mobile")) === null || _c === void 0 ? void 0 : _c.classList.add("is-transitioned");
                            (_d = document.getElementById("save-search-button-mobile-map")) === null || _d === void 0 ? void 0 : _d.classList.add("is-transitioned");
                            //this is needed because the map is not centered correctly on mobile devices that have a height less than 770px
                            if (innerHeight < 770) {
                              space = 0.0005;
                              lat = +(marker.getLatLng().lat - space).toFixed(6);
                              this.map.setCenter(lat, marker.getLatLng().lng, 18);
                            } else this.map.setCenter(marker.getLatLng().lat, marker.getLatLng().lng, this.map.getZoom());
                          }
                          this.isPreviewCardSidebarVisible = true;
                          if (!this.lastMarkersClicked.find(function (id) {
                            return marker["id"].includes(id);
                          })) {
                            _context4.next = 6;
                            break;
                          }
                          this.loadingPreviewCard = true;
                          return _context4.abrupt("return");
                        case 6:
                          this.loadingPreviewCard = false;
                          _context4.prev = 7;
                          this.lastMarkersClicked = [];
                          (_this$lastMarkersClic = this.lastMarkersClicked).push.apply(_this$lastMarkersClic, _toConsumableArray(marker["id"]));
                          _context4.next = 12;
                          return buildInfoWindow(marker["id"]);
                        case 12:
                          this.previewCardRealEstateMap = _context4.sent;
                          this.loadingPreviewCard = true;
                          _context4.next = 19;
                          break;
                        case 16:
                          _context4.prev = 16;
                          _context4.t0 = _context4["catch"](7);
                          console.error(_context4.t0);
                        case 19:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, this, [[7, 16]]);
                  }));
                });
              })["finally"](function () {
                _this5.map.stopSpinner();
              });
              _context5.next = 21;
              break;
            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](10);
              console.error(_context5.t0);
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[10, 18]]);
      }));
    },
    setActiveMode: function setActiveMode(newMode) {
      this.activeMode = newMode;
    },
    hidePopoverMailAlert: function hidePopoverMailAlert() {
      if (!this.popoverVisible) return;
      this.popoverVisible = false;
      encodeCookie("saveSearchModal", {}, 1);
    },
    scrollLeft: function scrollLeft() {
      var seoFilters = this.seoFilters;
      var scrollLeft = seoFilters.scrollLeft,
        scrollWidth = seoFilters.scrollWidth,
        offsetWidth = seoFilters.offsetWidth;
      var newScrollLeft = scrollLeft - 180;
      seoFilters.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
      this.handleArrowVisibilityOfSeoFilters(newScrollLeft, scrollWidth, offsetWidth);
    },
    scrollRight: function scrollRight() {
      var seoFilters = this.seoFilters;
      var scrollLeft = seoFilters.scrollLeft,
        scrollWidth = seoFilters.scrollWidth,
        offsetWidth = seoFilters.offsetWidth;
      var newScrollLeft = scrollLeft + 180;
      seoFilters.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
      this.handleArrowVisibilityOfSeoFilters(newScrollLeft, scrollWidth, offsetWidth);
    },
    handleScrolling: function handleScrolling() {
      this.handleArrowVisibilityOfSeoFilters(this.seoFilters.scrollLeft, this.seoFilters.scrollWidth, this.seoFilters.offsetWidth);
    },
    handleArrowVisibilityOfSeoFilters: function handleArrowVisibilityOfSeoFilters(scrollLeft, scrollWidth, offsetWidth) {
      this.isBtnScrollLeftVisible = scrollLeft > 0;
      this.isBtnScrollRightVisible = scrollWidth - Math.round(scrollLeft) > offsetWidth;
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useSearchBeanStore, ["updateSearchBean"])), mapActions(useModalStore, ["setShowModal"])), mapActions(usePublicUserMenuStore, ["increaseSavedSearches", "getFavoriteById"]))
});
realEstateListingApp.use(createPinia());
realEstateListingApp.mount("#real-estate-main");
// Stefano S. this var is need for creating url correctly within infoWindows on map view listings
var urlLang = window["_lang"] == "it" ? "" : "/" + window["_lang"];
var dispatchInitFavoritesEvent = function dispatchInitFavoritesEvent(realEstateIdList) {
  var initFavoriteEvent = new CustomEvent("init-favorite-event", {
    detail: {
      realEstateIdList: realEstateIdList
    }
  });
  document.dispatchEvent(initFavoriteEvent);
};
var dispatchChangeFavoriteEvent = function dispatchChangeFavoriteEvent(realEstateId, action) {
  var changeFavoriteEvent = new CustomEvent("change-favorite-event", {
    detail: {
      realEstateId: realEstateId,
      action: action
    }
  });
  document.dispatchEvent(changeFavoriteEvent);
};
var dispatchShareEvent = function dispatchShareEvent(title, url) {
  document.dispatchEvent(new CustomEvent("share-event", {
    detail: {
      title: title,
      url: url
    }
  }));
};
var isMapFavorite = function isMapFavorite(elem) {
  var dispatchEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (elem.classList.contains("fav-save")) {
    var realEstateId = Number(elem.getAttribute("data-id"));
    dispatchEvent && dispatchChangeFavoriteEvent(realEstateId, "save");
    return true;
  } else if (elem.classList.contains("fav-remove")) {
    var _realEstateId = Number(elem.getAttribute("data-id"));
    dispatchEvent && dispatchChangeFavoriteEvent(_realEstateId, "delete");
  }
  return false;
};
var isShareBtn = function isShareBtn(elem) {
  var dispatchEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!elem.classList.contains("share")) return false;
  dispatchEvent && dispatchShareEvent(elem.getAttribute("data-title"), elem.getAttribute("data-url"));
  return true;
};
var handleMapInsertionClick = function handleMapInsertionClick() {
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  var _iterator = _createForOfIteratorHelper(mediaWrapperList),
    _step;
  try {
    var _loop = function _loop() {
      var mediaWrapperEl = _step.value;
      insertionMediaWrapperClick = function insertionMediaWrapperClick(e) {
        return e.preventDefault();
      };
      //Avoid catching from children elements
      mediaWrapperEl.addEventListener("click", insertionMediaWrapperClick);
      var insertionMapEl = mediaWrapperEl.parentElement;
      if (!insertionMapEl) return 1; // continue
      var url = insertionMapEl.dataset.url;
      insertionHandlerClick = function insertionHandlerClick(_ref) {
        var target = _ref.target;
        var curTarget = target;
        var curTargetParent = curTarget.parentElement;
        //If we click the save btn or the share btn we won't redirect the user
        if (isMapFavorite(curTarget, false) || curTargetParent && isMapFavorite(curTargetParent, false) || isShareBtn(curTarget) || curTargetParent && isShareBtn(curTargetParent, false)) return;
        handleInsertionClick({
          url: url || "",
          blankPage: {
            lg: true
          }
        });
      };
      //Adding insertion on click handler
      insertionMapEl.addEventListener("click", insertionHandlerClick);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var removeMapInsertionClickListener = function removeMapInsertionClickListener() {
  var _a;
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  var _iterator2 = _createForOfIteratorHelper(mediaWrapperList),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var mediaWrapperEl = _step2.value;
      insertionMediaWrapperClick && mediaWrapperEl.removeEventListener("click", insertionMediaWrapperClick);
      insertionHandlerClick && ((_a = mediaWrapperEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", insertionHandlerClick));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  insertionHandlerClick = null;
  insertionMediaWrapperClick = null;
};
document.addEventListener("info-event-created", function (e) {
  var elems = document.querySelectorAll("#infowindow > .wrapper-multiple > li");
  handleMapInsertionClick();
  var realEstateIdList = [];
  elems.forEach(function (e) {
    var realEstateId = Number(e.getAttribute("data-id"));
    realEstateIdList.push(realEstateId);
  });
  dispatchInitFavoritesEvent(realEstateIdList);
  var carouselElems = document.getElementsByClassName("infowindow-carousel-container")[0];
  var infoWindowElem = document.getElementById("infowindow");
  var handleMapFavorite = function handleMapFavorite(e) {
    if (!e.target) return;
    var target = e.target;
    if (isMapFavorite(target)) return;
    if (isShareBtn(target)) return;
    var parentElement = target.parentElement;
    isMapFavorite(parentElement);
    isShareBtn(parentElement);
  };
  infoWindowElem === null || infoWindowElem === void 0 ? void 0 : infoWindowElem.addEventListener("click", handleMapFavorite);
  carouselElems === null || carouselElems === void 0 ? void 0 : carouselElems.addEventListener("click", handleMapFavorite);
});
function hideZonesBreadcrumb() {
  var zonesBreadcrumb = document.getElementById("navigation-dropdown-breadcrump");
  document.addEventListener("scroll", function () {
    zonesBreadcrumb === null || zonesBreadcrumb === void 0 ? void 0 : zonesBreadcrumb.classList.remove("show");
  }, {
    passive: true
  });
}
function buildInfoWindow(ids) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return getRealEstatesData(ids);
        case 3:
          data = _context6.sent;
          if (data) {
            _context6.next = 6;
            break;
          }
          return _context6.abrupt("return", []);
        case 6:
          return _context6.abrupt("return", data);
        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](0);
          console.error(_context6.t0);
          return _context6.abrupt("return", []);
        case 13:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 9]]);
  }));
}